import React from 'react';
import styled from 'styled-components';

const Styled = styled.hr``;

const Divider = () => <Styled />;

export default Divider;
